export default {
  settings: {
    label: 'Cài đặt',
    language: {
      label: 'Ngôn ngữ',
    },
  },
}
